import React from 'react';
import { HotelCardSkeleton } from '@lt/components';
import styled, { css } from 'styled-components';
import fadeInAndOut from 'src/components/animations/SkeletonFadeInAndOut';

type HotelsLoadingPreviewProps = {
  smallCard: boolean;
  visibleLimit?: number;
  penalizedHotelsVisibleLimit?: number;
};

const minSkeletonsNumber = 10;

export const HotelsLoadingPreview = ({
  smallCard = false,
  visibleLimit,
  penalizedHotelsVisibleLimit,
}: HotelsLoadingPreviewProps) => (
  <HotelsLoadingPreviewContainer smallCard={smallCard} className="loading">
    {Array(
      visibleLimit && penalizedHotelsVisibleLimit
        ? visibleLimit + penalizedHotelsVisibleLimit + minSkeletonsNumber
        : minSkeletonsNumber,
    )
      .fill(<Skeleton small={smallCard} />)
      .map((loading, idx) => (
        <StyledLoadingContainer
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          style={{ animationDelay: `${idx * 300}ms` }}
        >
          {loading}
        </StyledLoadingContainer>
      ))}
  </HotelsLoadingPreviewContainer>
);

const StyledLoadingContainer = styled.div`
  margin-bottom: 5px;
  opacity: 1;
  animation: ${fadeInAndOut} 1.2s ease-in-out infinite;
  width: 100%;
`;

const HotelsLoadingPreviewContainer = styled.div<{ smallCard: boolean }>`
  margin-top: 5px;

  ${({ smallCard }) =>
    smallCard &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}
`;

const Skeleton = styled(HotelCardSkeleton)`
  width: 100%;
`;
